module.exports = __webpack_public_path__ + "img/skiing3.3cefbb5a.jpg";